import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { AgentOfficeMessages } from "globalConstants";
import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseBoardAriseMutationProps = {
	onSuccess?: Function;
	onError?: Function;
	agentOfficeName: string;
};

const useBoardAriseMutation = ({
	onSuccess,
	onError,
	agentOfficeName,
}: UseBoardAriseMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId }: { companyId: string }) => {
			return agentOfficeSetupService.ariseBoarding(companyId);
		},
		{
			onSuccess(result) {
				dispatch(
					uiActions.showSuccessNotification({
						title: AgentOfficeMessages.ariseBoardingSuccess(
							agentOfficeName,
						),
					}),
				);

				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: `Agent Office was not submitted to ARISE \n${getErrorMessage(
							error,
						)}`,
						delay: 10000,
					}),
				);

				onError?.(error);
			},
		},
	);
};

export default useBoardAriseMutation;
